/* Copyright 2013-2015 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dijit/_Container",
    "dojo/text!./templates/QAGroup.html",
    "./_WidgetMixin",
    "./_ChildrenWrapperMixin",
    "../utils/DragSorter",
    "dojo/aspect"
], function (declare, lang, _WidgetBase, _TemplatedMixin, _Container, template, _WidgetMixin, _ChildrenWrapperMixin,
             DragSorter, aspect) {
    return declare([_WidgetBase, _TemplatedMixin, _Container, _WidgetMixin, _ChildrenWrapperMixin], {

        templateString: template,

        constructor: function () {
            var that = this;
            this.own(
                // Always add new children at 0 location in a Quick Access Group, if no index is provided.
                aspect.before(this, "addChild", function (widget, index) {
                    var newIndex = 0;
                    if (index >= 0) {
                        newIndex = index;
                    }
                    return [widget, newIndex];
                }),
                // The QAB might need to be shown if a new child is added to the Quick Access Group
                aspect.after(this, "addChild", function () {
                    var qab = that.getParent();
                    if (qab) {
                        qab.refresh();
                        var toolstrip = qab.getParent();
                        if(toolstrip) {
                            toolstrip.resize();
                        }
                    }
                }),
                // The QAB might need to be shown if a new child is added to the Quick Access Group
                aspect.after(this, "removeChild", function () {
                    var qab = that.getParent();
                    if (qab) {
                        qab.refresh();
                        var toolstrip = qab.getParent();
                        if(toolstrip) {
                            toolstrip.resize();
                        }
                    }
                })
            );
        },

        postCreate: function () {
            this.inherited(arguments);
            if (this.enableQABCustomization) {
                this._dragSorter = new DragSorter({
                    containerNode: this.containerNode
                });
                this._dragSorter.on("nodemoved", lang.hitch(this, function (data) {
                    this.itemMoved({
                        itemId: this.getChildren()[data.oldIndex].id,
                        newIndex: data.newIndex
                    });
                }));
            }
        },

        destroy: function () {
            if (this.enableQABCustomization) {
                this._dragSorter.destroy();
            }
            this.inherited(arguments);
        },

        itemMoved: function () {}
    });
});